import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Download, FileText } from "lucide-react";
import { motion } from "framer-motion";

const DataExportSection = ({ onExport, onDownloadPDF }) => (
  <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.3 }}>
    <Card className="glass">
      <CardHeader>
        <CardTitle className="text-lg text-white flex items-center gap-2">
          <Download className="w-5 h-5" />
          Export Your Data
        </CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-mystic-200/70 mb-4">Download your cycle logs, birth chart, and settings.</p>
        <div className="flex gap-3 flex-wrap">
          <Button
            onClick={() => onExport("json")}
            variant="outline"
            className="border-white/20 text-white hover:bg-mystic-700 rounded-full"
            data-testid="export-json-btn"
          >
            <Download className="w-4 h-4 mr-2" /> Export JSON
          </Button>
          <Button
            onClick={() => onExport("csv")}
            variant="outline"
            className="border-white/20 text-white hover:bg-mystic-700 rounded-full"
            data-testid="export-csv-btn"
          >
            <Download className="w-4 h-4 mr-2" /> Export CSV
          </Button>
          <Button
            onClick={onDownloadPDF}
            variant="outline"
            className="border-purple-500/30 text-purple-200 hover:bg-purple-600/20 rounded-full"
            data-testid="download-pdf-btn"
          >
            <FileText className="w-4 h-4 mr-2" /> Download PDF Report
          </Button>
        </div>
      </CardContent>
    </Card>
  </motion.div>
);

export default DataExportSection;
